import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { CriarUsuarioFormData } from "../schemas/usuario.schema";

interface ConfiguracoesProps {
  form: UseFormReturn<CriarUsuarioFormData>;
  ativo: boolean;
  readOnly?: boolean;
}

export const Configuracoes = ({ form, ativo, readOnly = false }: ConfiguracoesProps) => {
  // Para usuário PACIENTE (readOnly): apenas o checkbox "Usuário ativo" permanece habilitado
  return (
    <Card>
      <CardHeader>
        <CardTitle>Configurações</CardTitle>
      </CardHeader>
      <CardContent>
        <FormField
          control={form.control}
          name="ativo"
          render={({ field }) => (
            <FormItem className="flex items-center space-x-2 space-y-0">
              <FormControl>
                <input
                  type="checkbox"
                  checked={field.value}
                  onChange={field.onChange}
                  className="rounded"
                  disabled={false}
                />
              </FormControl>
              <FormLabel className="!mt-0">Usuário ativo</FormLabel>
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
};

